import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from '@/components/Layout'
import { Dashboard } from '@/pages/Dashboard'
import { Widget } from '@/pages/Widget'
import { Conversations } from '@/pages/Conversations'
import { ConversationDetail } from '@/pages/ConversationDetail'
import { Leads } from '@/pages/Leads'
import { LeadDetail } from '@/pages/LeadDetail'
import { Proposals } from '@/pages/Proposals'
import { ProposalDetail } from '@/pages/ProposalDetail'
import { Analytics } from '@/pages/Analytics'
import { Billing } from '@/pages/Billing'
import { Integrations } from '@/pages/Integrations'
import { Settings } from '@/pages/Settings'
import { Support } from '@/pages/Support'
import { SupportModule } from '@/pages/SupportModule'
import { SupportTicketDetail } from '@/pages/SupportModule/TicketDetail'
import { Reservations } from '@/pages/Reservations'
import { ReservationSettings } from '@/pages/ReservationSettings'
import { Help } from '@/pages/Help'
import { TeamMembers } from '@/pages/TeamMembers'
import { Onboarding } from '@/pages/Onboarding'
import { Login } from '@/pages/Login'
import { Register } from '@/pages/Register'
import { ConfirmDeleteAccount } from '@/pages/ConfirmDeleteAccount'
import { useAuthStore } from '@/stores/auth.store'

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, _hasHydrated } = useAuthStore()
  
  // Wait for hydration before deciding redirect
  if (!_hasHydrated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0a0a0f]">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-[#00d4aa]" />
      </div>
    )
  }
  
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="/delete-confirm" element={<ConfirmDeleteAccount />} />
      <Route path="/" element={
        <PrivateRoute>
          <Layout />
        </PrivateRoute>
      }>
        <Route index element={<Dashboard />} />
        <Route path="widget" element={<Widget />} />
        <Route path="conversations" element={<Conversations />} />
        <Route path="conversations/:id" element={<ConversationDetail />} />
        <Route path="leads" element={<Leads />} />
        <Route path="leads/:id" element={<LeadDetail />} />
        <Route path="proposals" element={<Proposals />} />
        <Route path="proposals/:id" element={<ProposalDetail />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="billing" element={<Billing />} />
        <Route path="integrations" element={<Integrations />} />
        <Route path="settings" element={<Settings />} />
        <Route path="team" element={<TeamMembers />} />
        <Route path="support" element={<Support />} />
        <Route path="support-module" element={<SupportModule />} />
        <Route path="support-module/tickets/:id" element={<SupportTicketDetail />} />
        <Route path="reservations" element={<Reservations />} />
        <Route path="reservations/settings" element={<ReservationSettings />} />
        <Route path="help" element={<Help />} />
      </Route>
    </Routes>
  )
}

export default App
